<div id="wave">
  <span class="dot"></span>
  <span class="dot"></span>
  <span class="dot"></span>
</div>